module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-ce063402.png";